export default __webpack_public_path__ + "static/media/2094.d0dd2618.png";